import { Box } from '@mui/material';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';

// Inspired by the former Facebook spinners.
function GRUFCircularProgress(props) {
  const { size } = props || {}
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={size ?? 40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          // color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
          color: "#2a2d64",
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={size ?? 40}
        thickness={4}
        {...props}
      />
    </Box>
  );
}

export default function GrufityCircularProgress({ defaultHeight }) {
  return (
    <Box sx={{ display: 'flex', height: defaultHeight ?? '100%', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
      <GRUFCircularProgress />
    </Box>
  );
}
